import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import Reference from '@/fhirworks/types/Reference';

export default class MedicationAdministrationPerformer extends BackboneElement {
    static __className = 'MedicationAdministrationPerformer';

    __objectStructure = {
        function: CodeableConcept,
        actor: Reference,
    };

    constructor(constructJson, className = 'MedicationAdministrationPerformer') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
